var map = {
	"./core/components/appointments/appointments.module": [
		"./src/app/core/components/appointments/appointments.module.ts",
		"default~core-components-appointments-appointments-module~core-components-chat-chat-module~core-compo~0393f560",
		"core-components-appointments-appointments-module"
	],
	"./core/components/chat/chat.module": [
		"./src/app/core/components/chat/chat.module.ts",
		"default~core-components-appointments-appointments-module~core-components-chat-chat-module~core-compo~0393f560",
		"core-components-chat-chat-module"
	],
	"./core/components/colleges/colleges.module": [
		"./src/app/core/components/colleges/colleges.module.ts",
		"default~core-components-appointments-appointments-module~core-components-chat-chat-module~core-compo~0393f560",
		"default~core-components-colleges-colleges-module~core-components-individual-college-individual-colle~27da479e",
		"core-components-colleges-colleges-module"
	],
	"./core/components/confirm-details/confirm-details.module": [
		"./src/app/core/components/confirm-details/confirm-details.module.ts",
		"core-components-confirm-details-confirm-details-module"
	],
	"./core/components/counsellor-assigned/counsellor-assigned.module": [
		"./src/app/core/components/counsellor-assigned/counsellor-assigned.module.ts",
		"core-components-counsellor-assigned-counsellor-assigned-module"
	],
	"./core/components/enrollment-form/enrollment-form.module": [
		"./src/app/core/components/enrollment-form/enrollment-form.module.ts",
		"core-components-enrollment-form-enrollment-form-module"
	],
	"./core/components/enrollment-submitted/enrollment-submitted.module": [
		"./src/app/core/components/enrollment-submitted/enrollment-submitted.module.ts",
		"core-components-enrollment-submitted-enrollment-submitted-module"
	],
	"./core/components/individual-college/individual-college.module": [
		"./src/app/core/components/individual-college/individual-college.module.ts",
		"default~core-components-appointments-appointments-module~core-components-chat-chat-module~core-compo~0393f560",
		"default~core-components-colleges-colleges-module~core-components-individual-college-individual-colle~27da479e",
		"core-components-individual-college-individual-college-module"
	],
	"./core/components/mentor-assigned/mentor-assigned.module": [
		"./src/app/core/components/mentor-assigned/mentor-assigned.module.ts",
		"core-components-mentor-assigned-mentor-assigned-module"
	],
	"./core/components/notifications/notifications.module": [
		"./src/app/core/components/notifications/notifications.module.ts",
		"default~core-components-appointments-appointments-module~core-components-chat-chat-module~core-compo~0393f560",
		"core-components-notifications-notifications-module"
	],
	"./core/components/pages/pages.module": [
		"./src/app/core/components/pages/pages.module.ts",
		"core-components-pages-pages-module"
	],
	"./core/components/profile/profile.module": [
		"./src/app/core/components/profile/profile.module.ts",
		"core-components-profile-profile-module"
	],
	"./core/components/recommendation/recommendation.module": [
		"./src/app/core/components/recommendation/recommendation.module.ts",
		"core-components-recommendation-recommendation-module"
	],
	"./core/components/roadmap/roadmap.module": [
		"./src/app/core/components/roadmap/roadmap.module.ts",
		"default~core-components-colleges-colleges-module~core-components-individual-college-individual-colle~27da479e",
		"core-components-roadmap-roadmap-module"
	],
	"./core/components/tutorial/tutorial.module": [
		"./src/app/core/components/tutorial/tutorial.module.ts",
		"core-components-tutorial-tutorial-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;